"use client";
import { j as i } from "./jsx-runtime-CJ-St4mQ.mjs";
import { u as v, a as C, c as x, d as M } from "./NavigationMenu.style-Dq96CLFG.mjs";
import * as E from "react";
import { createContext as T, useContext as k } from "react";
import { i as L } from "./isOutsideMenuEvent-QttO0YQ0.mjs";
import { C as R } from "./CompositeItem-DhB3Tdag.mjs";
import { u as j } from "./FloatingTree-vWe5pGqE.mjs";
const u = /* @__PURE__ */ E.forwardRef(function(e, n) {
  const {
    className: o,
    render: t,
    ...m
  } = e, {
    setValue: l,
    popupElement: r,
    positionerElement: p,
    rootRef: f
  } = v(), d = C(), g = j(), N = {
    tabIndex: void 0,
    onBlur(s) {
      p && r && L({
        currentTarget: s.currentTarget,
        relatedTarget: s.relatedTarget
      }, {
        popupElement: r,
        rootRef: f,
        tree: g,
        nodeId: d
      }) && l(null, s.nativeEvent, "focus-out");
    }
  };
  return /* @__PURE__ */ i.jsx(R, {
    tag: "a",
    render: t,
    className: o,
    refs: [n],
    props: [N, m]
  });
});
process.env.NODE_ENV !== "production" && (u.displayName = "NavigationMenuLink");
const c = T(!1), h = c.Provider, w = (a) => {
  const { className: e, ...n } = a, o = k(c), t = typeof e == "function" ? e({ open: !1 }) : e;
  return /* @__PURE__ */ i.jsx(
    u,
    {
      ...n,
      className: o ? x({ className: t }) : M({ className: t })
    }
  );
};
export {
  h as NavigationMenuContentProvider,
  w as default
};
